import { Component, ViewChild, ElementRef, Output, EventEmitter, OnInit, NgZone } from '@angular/core';
import { GoogleMapsService } from '../../services/google-maps.service';
import { Coordinate } from '../../models/Coordinate';
import {} from '@types/googlemaps';
import { Location } from '../../models/Location';

@Component({
  selector: 'mpf-map-config-location',
  templateUrl: './map-config-location.component.html',
  styleUrls: ['./map-config-location.component.scss']
})
export class MapConfigLocationComponent implements OnInit {
  @ViewChild('geocoder') geocoder: ElementRef;
  @Output() locationChange = new EventEmitter<Location>();

  autocomplete: google.maps.places.Autocomplete;

  constructor(private googleMapsService: GoogleMapsService, private zone: NgZone) {}

  ngOnInit() {
    this.googleMapsService.api.then(googleMaps => {
      this.autocomplete = new googleMaps.places.Autocomplete(this.geocoder.nativeElement);
      this.autocomplete.setTypes(['geocode']);

      googleMaps.event.addListener(this.autocomplete, 'place_changed', () => {
        // Here is the reason why do we need this.
        // https://github.com/SebastianM/angular-google-maps/issues/627
        this.zone.run(() => {
          this.onLocationSelected();
        });
      });
    });
  }

  onLocationSelected() {
    const placeResult = this.autocomplete.getPlace();
    const { geometry, address_components } = placeResult;

    if (geometry) {
      const { location } = geometry;

      const { country, city } = address_components.reduce(
        (acc, address) => {
          if (address.types.includes('country')) {
            acc.country = address.long_name;
          }

          if (address.types.includes('locality')) {
            acc.city = address.long_name;
          }

          return acc;
        },
        { country: '', city: '' }
      );

      const place: Location = {
        center: {
          lat: location.lat(),
          lng: location.lng()
        },
        country,
        city
      };

      this.locationChange.emit(place);
    }
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/components/map-config-location/map-config-location.component.ts